<style lang='less' scoped>
.sz-dialog-diallel {
   display: flex;
   overflow: auto;
   box-sizing: border-box;
   .sidebar {
      width: 220px;
      box-sizing: border-box;
      overflow: auto;
      border-right: 1px solid #e4e5ea;
      padding: 12px;
   }
   .main {
      flex: 1;
      box-sizing: border-box;
      padding: 16px;
      flex-shrink: 0;
      overflow: auto;
   }
}
</style>

<template>
   <div class="sz-dialog-diallel" :style="{ height: height }">
      <div class="sidebar">
         <slot name="sidebar" />
      </div>
      <div class="main">
         <slot name="main" />
      </div>
   </div>
</template>

<script lang='ts'>
import { defineComponent, PropType, reactive } from "vue";
export default defineComponent({
   props: {
      height: {
         type: [String],
         default: "560px",
      },
   },
   setup() {
      return {};
   },
   /****************************************************************
    *
    *
    *
    ***************************************************************/
});
</script>